import { PageType } from "./bi.enum";

const BEST_KEYWORD_PATH =
  /^\/best\/(?<category>[^/]+)\/(?<subCategory>[^/]+)\/(?<keyword>[^/]+)$/;

export function inferPageType(pathname: string): PageType | null {
  if (pathname === "/") return PageType.Homepage;
  if (pathname.startsWith("/search")) return PageType.Search;
  if (pathname.startsWith("/pages")) return PageType.Page;
  if (BEST_KEYWORD_PATH.test(pathname)) return PageType.Best;
  return null;
}
